<template>
  <div class="card" :style="cardStyle" @click="clickHandler">
    <img :src="cardInfo.icon" alt="" class="icon">
    <div>
      <div class="title">
        {{ cardInfo.title }}
      </div>
      <div class="content">
        {{ cardInfo.content }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex';

  export default {
    props : [ 'cardInfo' ],

    computed : {
      cardStyle() {
        return {
          backgroundColor : this.cardInfo.color
        };
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [ 'updateSearchType' ] ),

      clickHandler() {
        this.updateSearchType( this.cardInfo.type );

        this.$router.push( {
          path : '/virusTrip/search'
        } );
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./card.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/home/card.vue